import React from 'react';
import Column from '@amzn/meridian/column';
import Loader from '@amzn/meridian/loader';
import { AuthProvider, useAuth } from './auth/AuthContext';
import AppShell from './components/AppShell';
import AuthFlow from './screens/AuthFlow';
import LandingScreen from './screens/LandingScreen';

function AppBody() {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <AppShell>
                <Column alignmentHorizontal="center" spacingInset="600">
                    <Loader />
                </Column>
            </AppShell>
        );
    }

    if (user) {
        return <LandingScreen />;
    }

    return (
        <AppShell>
            <AuthFlow />
        </AppShell>
    );
}

function App() {
    return (
        <AuthProvider>
            <AppBody />
        </AuthProvider>
    );
}

export default App;
